/**
 * Detecta si un error es de red, cobertura o petición abortada de forma robusta.
 * Unifica la lógica de detección dispersa en la aplicación.
 */
export function isNetworkError(err: unknown): boolean {
  if (!err) return false;

  const name = (err as any)?.name || '';
  const msg = (err as any)?.message || String(err);

  // Considerar offline si el navegador lo indica o si las pruebas E2E 
  // fuerzan el estado offline mediante __TEST_FORCE_OFFLINE__.
  const isOffline =
    (typeof window !== 'undefined' && (window as any).__TEST_FORCE_OFFLINE__ === true) ||
    (typeof navigator !== 'undefined' && !navigator.onLine);

  return (
    msg.includes('Failed to fetch') ||
    msg.includes('NetworkError') ||
    msg.includes('Network request failed') ||
    msg.includes('timeout') ||
    msg.includes('AbortError') ||
    msg.includes('aborted') ||
    name.includes('AbortError') ||
    name.includes('NetworkError') ||
    isOffline
  );
}
